function initSingleTabs() {
  const tabsSections = document.querySelectorAll(".site-tabs-list");

  if (!tabsSections.length) {
    return;
  }

  tabsSections.forEach((section) => {
    const tabs = section.querySelectorAll(".site-tabs-item");

    if (!tabs.length) {
      return;
    }

    tabs.forEach((tab) => {
      const tabHeading = tab.querySelector(".site-tabs-item__heading");

      tabHeading?.addEventListener("click", () => {
        if (tab.classList.contains("active")) {
          tab.classList.remove("active");
        } else {
          tabs.forEach((tab) => tab.classList.remove("active"));
          tab.classList.add("active");
        }
      });
    });
  });
}

function initImageCarousel() {
  const sliders = document.querySelectorAll(".image-carousel-section_carousel");

  if (!sliders.length) {
    return;
  }

  sliders.forEach((slider) => {
    const nextButton = slider
      .closest(".image-carousel-section-row")
      ?.querySelector(".carousel_nav_next");
    const prevButton = slider
      .closest(".image-carousel-section-row")
      ?.querySelector(".carousel_nav_prev");

    const swiper = new Swiper(slider, {
      slidesPerView: 2.5,
      spaceBetween: 10,
      loop: true,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      breakpoints: {
        545: {
          spaceBetween: 20,
        },
      },
    });
  });
}

function playVideoCards() {
  const cards = document.querySelectorAll(
    ".video-cards__item, .single-video-section__content, .media-banner-video"
  );

  if (!cards) {
    return;
  }

  cards.forEach((card) => {
    const playButton = card.querySelector(".video_play_button");
    const playButtonImage = card.querySelector(".video_play_button svg");
    const video = card.querySelector("video");
    const spinner = card.querySelector(".video_spinner");

    playButton.addEventListener("click", () => {
      video.onwaiting = function () {
        spinner.classList.remove("hide");
      };

      video.onplaying = function () {
        spinner.classList.add("hide");
      };

      if (video.classList.contains("lazy")) {
        const videoSources = Array.from(video.querySelectorAll("source"));

        if (!videoSources.length) {
          return;
        }

        videoSources.forEach((source) => {
          source.src = source.dataset.src;
        });

        video.load();
        video.classList.remove("lazy");
      }

      if (video.paused) {
        pauseAllVideos(cards);
        playButtonImage.classList.add("hide");
        video.play();
      } else {
        playButtonImage.classList.remove("hide");
        video.pause();
      }
    });
  });

  function pauseAllVideos(video_cards) {
    video_cards.forEach((video) => {
      const videoPlayer = video.querySelector("video");
      const playButtonImage = video.querySelector(".video_play_button svg");

      playButtonImage.classList.remove("hide");
      videoPlayer.pause();
    });
  }
}

function initMegaMenu() {
  const menuLinks = document.querySelectorAll(".mega-menu-item span");
  const menuBlocks = document.querySelectorAll(".mega-menu-block");
  const tabLinks = document.querySelectorAll(".mega-menu-row ul li");

  if (!menuLinks.length) {
    return;
  }

  tabLinks.forEach((tabLink) =>
    tabLink.addEventListener("click", () => {
      const tabID = tabLink.dataset.tabId;
      const parentRow = tabLink.closest(".mega-menu-row");
      const groupLinks = parentRow.querySelectorAll(
        ".mega-menu-list_links ul li"
      );
      const groupItems = parentRow.querySelectorAll(".mega-menu-tab-item");

      if (tabLink.classList.contains("active")) {
        return;
      }

      groupLinks.forEach((item) => item.classList.remove("active"));
      groupItems.forEach((item) => item.classList.remove("active"));

      tabLink.classList.add("active");
      groupItems.forEach((item) => {
        if (item.dataset.tabId == tabID) {
          item.classList.add("active");
        }
      });
    })
  );
}

function initCountdownTimers() {
  const timers = document.querySelectorAll(".countdown-timer");

  if (!timers.length) {
    return;
  }

  timers.forEach((timer) => {
    const day = +timer.dataset.day;
    const month = +timer.dataset.month;
    const year = +timer.dataset.year;
    const hours = +timer.dataset.hours;
    const minutes = +timer.dataset.minutes;

    timer.innerHTML = "";

    simplyCountdown(timer, {
      year: year,
      month: month,
      day: day,
      hours: hours,
      minutes: minutes,
      seconds: 0,
      words: {
        days: { singular: "day", plural: "days" },
        hours: { singular: "hour", plural: "hours" },
        minutes: { singular: "minute", plural: "minutes" },
        seconds: { singular: "second", plural: "seconds" },
      },
      plural: true,
      inline: false,
      enableUtc: false,
      zeroPad: false,
      onEnd: function () {
        timer.closest(".soldout-block-message").classList.add("hidden");
      },
    });
  });
}

function showFeatureProductArticle() {
  const featuredPanel = document.querySelector(".article-feature-product");

  if (!featuredPanel) {
    return;
  }

  const featuredPanelHeight = featuredPanel.clientHeight;
  document.body.style.paddingBottom = `${featuredPanelHeight}px`;

  const scrollHeight = Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.body.clientHeight,
    document.documentElement.clientHeight
  );
  const triggerPoint = scrollHeight / 5;

  window.addEventListener("scroll", (event) => {
    const scrollFromTop = window.scrollY;

    if (scrollFromTop > triggerPoint) {
      featuredPanel.classList.add("active");
    } else {
      featuredPanel.classList.remove("active");
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initMegaMenu();
  initSingleTabs();
  initImageCarousel();
  playVideoCards();
  initCountdownTimers();
  showFeatureProductArticle();
});

document.addEventListener("resize", () => {
  showFeatureProductArticle();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    initCountdownTimers();
  });
}
